import { CheckboxFormsy, SelectFormsy, TextFieldFormsy } from '@fuse';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import classNames from 'classnames';
import Formsy from 'formsy-react';
import AddCustomer from "main/content/crm/widgets/addCustomer";
import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogContentText, Icon, IconButton, InputAdornment, MenuItem, TextField, Toolbar, Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import Loader from "other-components/loader/loader";
import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactTable from "react-table";

var task = [];

class jobNew extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openComposeDialog: false,
            openCustomerDialog: false,
            loading: false,
            customers: [],
            brokers: [],
            employees: [],
            tasks: [],
            subTasks: [],
            items: [],
            jobCustomer: null,
            jobItem: null,
            jobCode: {
                'prefix': 'JB ' + new Date().getFullYear().toString().substr(-2),
                'code': '0000',
                'suffix': ''
            },
            sticker_no: "",
            nextServiceDate: ' ',
            serviceDate: new Date().getFullYear() + "-" + ("0" + ((new Date().getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (new Date().getDate().toString())).substr(-2),
            frequency: null,
            contactPersons: [],
            contactPersonsIndex: 0,
            employeeId: 0,
            expectedDate: " ",
            jobNo: "",
            tooltipText: "",
            quotationNumbers: [],
            quotationNumber: '',
            quotationLabel: '',
            openServiceTypeDialog: false,
            quotationItems: [],
            selectedServiceType: 'C',
            serviceTypes: [
                                {
                                    value: 'C',
                                    label: 'Calibrate'
                                },
                                {
                                    value: 'R',
                                    label: 'Repair'
                                },
                                {
                                    value: 'RC',
                                    label: 'Repair & Calibrate'
                                }
                            ]
        };

        this.setJobCustomer = this.setJobCustomer.bind(this);
        this.addJob = this.addJob.bind(this);
        this.addTask = this.addTask.bind(this);
        this.closeSubTaskDialog = this.closeSubTaskDialog.bind(this);
        this.setNextServiceDate = this.setNextServiceDate.bind(this);
        this.closeCustomerDialog = this.closeCustomerDialog.bind(this);
        this.setLoader = this.setLoader.bind(this);
        this.changeContactPerson = this.changeContactPerson.bind(this);
        this.getJobCode = this.getJobCode.bind(this);
        this.handleCloseServiceTypeDialog = this.handleCloseServiceTypeDialog.bind(this);
        this.addTaskFromQuatation = this.addTaskFromQuatation.bind(this);
    }

    handleCloseServiceTypeDialog = () => {
        this.setState({ openServiceTypeDialog: false });
    };

    getCustomerList() {

        var customer = [];

        // axios.get('http://localhost:5003/crm/getCustomer/min')
        axios.get(window.crmServer + '/crm/getCustomer/min')
            .then(response => {

                for (let i = 0; i < response.data.result.length; i++) {
                    const resultItem = response.data.result[i];

                    if (resultItem && typeof resultItem === 'object') {
                        const customerProfile = resultItem.CUSTOMER_PROFILE || {};
                        const customerName = customerProfile.cx_name || "";
                        const city = customerProfile.cx_billing_address_city || "";
                        const formattedString = `${customerName} ${city ? `(${city})` : ""}`;
                        customer.push({
                            value: response.data.result[i].ID_CUSTOMER_PROFILE,
                            label: formattedString,
                            toolTip: customerProfile.cx_billing_address
                        });
                    }
                }
                this.setState({ customers: customer });
            });
    }

    getJobCode() {
        axios.get(window.crmServer + '/job/getJobCode')
            .then(response => {
                if (response.data.result) {
                    this.setState({ jobNo: response.data.result.jobCode });
                }
            });
    }


    componentDidMount() {
        this.getJobCode();
    }



    openSubTaskDialog(element) {
        this.setState({ subTasks: element });
        this.setState({ openComposeDialog: true });
    }

    closeSubTaskDialog() {
        this.setState({ openComposeDialog: false });
    }

    setJobItem = (selectedOption) => {

        this.setState({ jobItem: selectedOption });
        if (selectedOption) {
            this.refs.task_instrument_name.setValue(selectedOption.text);
            this.refs.task_instrument_id.setValue(selectedOption.value);

        }
        else {

            this.refs.task_instrument_name.setValue('');
            this.refs.task_instrument_id.setValue('');
        }
    }


    setJobCustomer = (selectedOption) => {
        this.setState({ jobCustomer: selectedOption.target.value });
        if (selectedOption.target) {

            this.refs.job_postal_address.setValue('Loading...');
            this.refs.job_billing_address.setValue('Loading...');
            this.refs.job_cp_name.setValue('Loading...');
            this.refs.job_cp_mobile.setValue('Loading...');
            this.refs.job_cp_office.setValue('Loading...');
            this.refs.job_cp_home.setValue('Loading...');
            this.refs.job_cp_email.setValue('Loading...');
            this.refs.job_customer_id.setValue(selectedOption.target.value);

            // axios.post('http://localhost:5003/crm/getCustomer/byId',{'id':selectedOption.value})
            axios.post(window.crmServer + '/crm/getCustomer/byId', { 'id': selectedOption.target.value })
                .then(response => {

                    this.setState({ contactPersons: response.data.result[0].CONTACT_PERSONS });
                    this.setState({ contactPersonsIndex: 0 });

                    if (response.data.result[0].CUSTOMER_PROFILE) {
                        this.refs.job_postal_address.setValue(response.data.result[0].CUSTOMER_PROFILE.cx_postal_address);
                        this.refs.job_billing_address.setValue(response.data.result[0].CUSTOMER_PROFILE.cx_billing_address);
                    }
                    else {
                        this.refs.job_postal_address.setValue('');
                        this.refs.job_billing_address.setValue('');
                    }

                    if (response.data.result[0].CONTACT_PERSONS[0]) {
                        this.refs.job_cp_name.setValue(response.data.result[0].CONTACT_PERSONS[0].name);
                        this.refs.job_cp_mobile.setValue(response.data.result[0].CONTACT_PERSONS[0].phone_mobile);
                        this.refs.job_cp_office.setValue(response.data.result[0].CONTACT_PERSONS[0].phone_office);
                        this.refs.job_cp_home.setValue(response.data.result[0].CONTACT_PERSONS[0].phone_home);
                        this.refs.job_cp_email.setValue(response.data.result[0].CONTACT_PERSONS[0].email);
                    }
                    else {
                        this.refs.job_cp_name.setValue('');
                        this.refs.job_cp_mobile.setValue('');
                        this.refs.job_cp_office.setValue('');
                        this.refs.job_cp_home.setValue('');
                        this.refs.job_cp_email.setValue('');
                    }
                });
        }
        else {

            this.setState({ contactPersons: [] });
            this.refs.job_postal_address.setValue('');
            this.refs.job_billing_address.setValue('');
            this.refs.job_cp_name.setValue('');
            this.refs.job_cp_mobile.setValue('');
            this.refs.job_cp_office.setValue('');
            this.refs.job_cp_home.setValue('');
            this.refs.job_cp_email.setValue('');
        }
    }

    addJob = (formData) => {

        if (!formData.job_is_outbound && formData.job_expected_date === " " && window.env !== "IMC") {

            this.props.alert.error("Expected Completed Date Required for Inbound Jobs");
        }

        else {

            this.setState({ loading: true });
            var data = {

                'jobGeneral': formData,
                'jobTasks': this.state.tasks
            }

            task = [];
            this.setState({ tasks: task });
            this.setState({ jobCustomer: null });
            this.setState({ jobItem: null });

            // axios.post('http://localhost:5003/job/addJob',data)
            axios.post(window.crmServer + '/job/addJob', data)
                .then(response => {
                    if (response.data.status) {

                        var report = '';

                        if (window.env != "IMC"){
                            if (formData.job_is_outbound) report = window.reportServer + '/report/get/jobRegistationOutBound';
                            else report = window.reportServer + '/report/get/jobRegistationInBound';
                        }else{
                            if (formData.job_is_outbound) report = window.reportServer + '/report/get/jobRegistationOutBoundImc';
                            else report = window.reportServer + '/report/get/jobRegistationInBoundImc';
                        }

                        var path = null;
                        axios.get(report, {
                            params: {
                                jobNo: response.data.id
                            }
                        })
                            .then(response2 => {
                                path = response2.data.path;
                                path = window.reportServer + "/" + path;
                                const url = path;
                                window.open(url, '_blank');

                            }
                            );
                        this.setState({ loading: false });
                        this.props.alert.success(response.data.msg);
                    }

                    else {
                        this.setState({ loading: false });
                        this.props.alert.error(response.data.msg);
                    }
                });

        }
    }

    setExpectedDate = (data) => {

        // alert(data.target.value.substr(1));

        this.setState({ expectedDate: data.target.value });

        if (data.target.value.substr(0, 1) > 0) {

            var d1 = new Date(this.state.serviceDate);
            var d2 = new Date(data.target.value);

            if (d1.getTime() > d2.getTime()) {

                this.props.alert.error("Expected Date Should be Grater than Service Date");
                this.setState({ expectedDate: " " });
            }
            else {
                this.setState({ expectedDate: data.target.value });
            }
        }
    }

    setNextServiceDate = (data) => {

        if (data.target.name == 'job_date_tmp') {

            this.setState({ serviceDate: data.target.value }, () => {
                var nextServiceDate = this.state.serviceDate;
                var n = parseInt(this.state.frequency);

                var d = new Date(nextServiceDate);
                var dt = new Date(d.setMonth(d.getMonth() + n));
                var nextServiceDate = dt.getFullYear() + "-" + ("0" + ((dt.getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (dt.getDate().toString())).substr(-2);
                this.setState({ nextServiceDate: nextServiceDate });
            });
        }

        else if (data.target.name == 'job_frequency_tmp') {

            this.setState({ frequency: data.target.value }, () => {
                var nextServiceDate = this.state.serviceDate;
                var n = parseInt(this.state.frequency);

                var d = new Date(nextServiceDate);
                var dt = new Date(d.setMonth(d.getMonth() + n));
                var nextServiceDate = dt.getFullYear() + "-" + ("0" + ((dt.getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (dt.getDate().toString())).substr(-2);
                this.setState({ nextServiceDate: nextServiceDate });
            });
        }

        else {
            var nextServiceDate = this.state.serviceDate;
            var n = parseInt(this.state.frequency);

            var d = new Date(nextServiceDate);
            var dt = new Date(d.setMonth(d.getMonth() + n));
            var nextServiceDate = dt.getFullYear() + "-" + ("0" + ((dt.getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (dt.getDate().toString())).substr(-2);
            this.setState({ nextServiceDate: nextServiceDate });
        }

    }

    openNewCustomerDialog() {
        this.setState({ openCustomerDialog: true });
    }

    closeCustomerDialog() {
        this.setState({ openCustomerDialog: false });
    }

    setLoader(status) {
        if (status) {
            this.setState({ loading: status });
        }

        else {
            this.getCustomerList();
            this.setState({ loading: status });
        }
    }

    addTask = () => {

        if (this.refs.task_instrument_id.getValue() != '') {

            var subTask = [];

            for (var i = 0; parseInt(this.refs.task_qty.getValue()) > i; i++) {

                subTask.push({
                    'subTask_code': this.state.jobNo + ' ' + ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue() + ' ' + ('0' + (i + 1).toString()).substr(-2),
                    'subTask_code_suffix': ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue() + ' ' + ('0' + (i + 1).toString()).substr(-2),
                    'subTask_type': this.refs.task_service_type.getValue(),
                    'subTask_instrument': this.refs.task_instrument_name.getValue(),
                    'subTask_instrument_id': this.refs.task_instrument_id.getValue(),
                });
            }

            task.push({
                'task_code': this.state.jobNo + ' ' + ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue(),
                'task_code_suffix': ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue(),
                'task_type': this.refs.task_service_type.getValue(),
                'task_qty': this.refs.task_qty.getValue(),
                'task_instrument': this.refs.task_instrument_name.getValue(),
                'task_instrument_id': this.refs.task_instrument_id.getValue(),
                'task_remark': this.refs.task_remark.getValue(),
                'sub_tasks': subTask,
            });

            this.setState({ tasks: task });
            this.setState({ jobItem: null });

            this.refs.task_service_type.setValue("C");
            this.refs.task_qty.setValue("1");
            this.refs.task_instrument_name.setValue("");
            this.refs.task_instrument_id.setValue("");
            this.refs.task_remark.setValue("");

        }
    }

    removeTaskConfirm = (element) => {

        confirmAlert({
            title: 'Confirm to Remove',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.removeTask(element)
                },
                {
                    label: 'No'
                }
            ]
        })
    }

    removeTask = (element) => {

        var taskNew = [];

        task = [...this.state.tasks];
        var index = task.indexOf(element)
        task.splice(index, 1);

        for (var i = 0; task.length > i; i++) {
            taskNew.push({
                'task_code': this.state.jobNo + ' ' + ('0' + (i + 1).toString()).substr(-2) + ' ' + task[i].task_type,
                'task_code_suffix': ('0' + (i + 1).toString()).substr(-2) + ' ' + task[i].task_type,
                'task_type': task[i].task_type,
                'task_qty': task[i].task_qty,
                'task_instrument': task[i].task_instrument,
                'task_instrument_id': task[i].task_instrument_id,
                'task_remark': task[i].task_remark,
                'sub_tasks': task[i].sub_tasks,
            });
        }

        this.setState({ tasks: taskNew });
    }

    changeContactPerson = (index) => {

        if (index + 1 < this.state.contactPersons.length) {
            this.refs.job_cp_name.setValue(this.state.contactPersons[index].name);
            this.refs.job_cp_mobile.setValue(this.state.contactPersons[index].phone_mobile);
            this.refs.job_cp_office.setValue(this.state.contactPersons[index].phone_office);
            this.refs.job_cp_home.setValue(this.state.contactPersons[index].phone_home);
            this.refs.job_cp_email.setValue(this.state.contactPersons[index].email);
            this.setState({ contactPersonsIndex: index + 1 });
        }

        if (index + 1 == this.state.contactPersons.length) {
            this.refs.job_cp_name.setValue(this.state.contactPersons[index].name);
            this.refs.job_cp_mobile.setValue(this.state.contactPersons[index].phone_mobile);
            this.refs.job_cp_office.setValue(this.state.contactPersons[index].phone_office);
            this.refs.job_cp_home.setValue(this.state.contactPersons[index].phone_home);
            this.refs.job_cp_email.setValue(this.state.contactPersons[index].email);
            this.setState({ contactPersonsIndex: 0 });
        }
    }

    getQuotations() {
        const request = axios.get(window.salesServer + '/quotation/getQuotations');
        request.then((response) => {

            if (!response.data.error) {
                let data = [];

                for (let i = 0; i < response.data.quotations.length; i++) {
                    data.push({ value: response.data.quotations[i].ID_QUOTATION_HEADER, label: response.data.quotations[i].REFERENCE_NO });
                }

                this.setState({ rawQuotations: response.data.quotations, quotationNumbers: data });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    handleQuotationChange = (selectedOption) => {
        console.log(selectedOption)
        this.setState(
            {
                quotationNumber: selectedOption.value,
                quotationLabel: selectedOption.label,
                job: '',
                tasks: []
            }
        );

        if (selectedOption) {
            task = [];
            let body = {
                id: selectedOption.value
            };
            var url = window.salesServer + "/quotation/getQuotationById";
            const request = axios.post(url, body);

            request.then((response) => {

                if (!response.data.error && response.data.success) {
                    this.setJobCustomer({target: {value:response.data.quotation[0].CUSTOMER_ID}});
                }
                else {
                    this.setState({ loading: false });

                    console.log('error', response.data.error);
                }
            })
                .catch((error) => {
                    // Error
                    if (error && typeof error === 'undefined') {
                        console.log('login axios error block', error);
                    }
                    else if (error) {
                        console.log('error', error);
                    }
                    this.setState({ loading: false });

                });


            var url2 = window.salesServer + "/quotation/getQuotationItemsById";
            let body2 = {
                id: selectedOption.value
            };
            const request2 = axios.post(url2, body2);

            request2.then((response) => {

                if (!response.data.error && response.data.success) {
                    var items = response.data.items || [];
                    items.forEach(function(item) {
                        item.SERVICE_TYPE = item.SERVICE_TYPE || "C";
                      });
                    if(items){
                        this.setState({ quotationItems: items });
                        this.setState({ openServiceTypeDialog: true });
                    }
                }
                this.setState({ loading: false });
            })
                .catch((error) => {
                    // Error
                    if (error && typeof error === 'undefined') {
                        console.log('login axios error block', error);
                    }
                    else if (error) {
                        console.log('error', error);
                    }
                    this.setState({ loading: false });

                });

        }
    }

    changeServiceType = (event, index) => {
        const selectedValue = event.target.value;
        if (selectedValue) {
          this.setState(prevState => {
            const updatedItems = [...prevState.quotationItems];
            updatedItems[index] = { ...updatedItems[index], ['SERVICE_TYPE']: selectedValue };
            return { quotationItems: updatedItems };
          });
        }
      };

      addTaskFromQuatation = (index, data) => {
        this.setState(prevState => {
            const updatedItems = [...prevState.quotationItems];
            updatedItems[index] = { ...updatedItems[index], ['added']: true };
            return { quotationItems: updatedItems };
          });

        this.refs.task_instrument_id.setValue(data.ITEM_ID);
        this.refs.task_service_type.setValue(data.SERVICE_TYPE || 'C');
        this.refs.task_qty.setValue(data.ITEM_QTY);
        this.refs.task_instrument_name.setValue(data.ITEM_NAME);
        this.refs.task_remark.setValue(data.REMARKS);

        setTimeout(this.addTask, 10);
      };

    

    render() {
        const { classes } = this.props;
        const { subTasks } = this.state;

        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <React.Fragment>

                    <Toolbar className="flex w-full pt-24 px-12">
                        <h2 className="w-full subtitle-color">
                            Job Registration
                        </h2>
                        <div className="px-12">

                        </div>
                    </Toolbar>

                    <Formsy
                        onValidSubmit={this.addJob}
                        ref='newJobForm'
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className={classNames(classes.root, " m-12 p-20 border-2 border-green-darkest")}
                    >
                        <div className="flex flex-wrap">
                            <div className="w-full md:w-2/5 px-12">
                                <div className="w-full px-8  inline-block ">
                                    Recall Quotation
                                    <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Quotation"
                                        value={this.state.quotationNumber}
                                        onChange={this.handleQuotationChange}
                                        options={this.state.quotationNumbers}
                                    />
                                    <TextFieldFormsy
                                        type="hidden"
                                        name="quotationNo"
                                        ref="quotationNo"
                                        value={this.state.quotationLabel}
                                    />
                                </div>
                                <select
                                    className="w-full md:w-1/2 mx-12 m-16"
                                    name="job_customer"
                                    value={this.state.jobCustomer}
                                    onChange={this.setJobCustomer}
                                    style={{ padding: 10 }}
                                    required
                                >
                                    <option value='0'>--Select--</option>
                                    {this.state.customers.map(option => (
                                        <option key={option.value} value={option.value} title={option.toolTip}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                                {/* <Select
                                    className="w-full md:w-1/2 pt-4 mt-12 float-left"
                                    name="job_customer"
                                    placeholder="Search Customer"
                                    value={this.state.jobCustomer}
                                    onChange={this.setJobCustomer}
                                    options={this.state.customers}
                                /> */}

                                <Button
                                    type="button"
                                    variant="raised"
                                    color="secondary"
                                    size="small"
                                    className='md:w-1/3 m-16 float-right'
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.openNewCustomerDialog();
                                    }}
                                >
                                    Add New Customer
                                </Button>

                                <div className="w-full md:w-2/3 px-8 float-left"></div>

                                <TextFieldFormsy
                                    type="hidden"
                                    name="job_customer_id"
                                    ref="job_customer_id"
                                />

                                <CheckboxFormsy
                                    className=" float-left"
                                    name="job_is_outbound"
                                    label="Outbound"
                                />

                                <TextField
                                    className="w-full md:w-2/5 float-right"
                                    type="date"
                                    name="job_date_tmp"
                                    label="Date of Service"
                                    value={this.state.serviceDate}
                                    onChange={(ev) => {
                                        this.setNextServiceDate(ev);
                                    }}
                                    required
                                />

                                <TextFieldFormsy
                                    type="hidden"
                                    name="job_date"
                                    value={this.state.serviceDate}
                                />

                                <TextFieldFormsy
                                    className="w-full mt-12"
                                    type="text"
                                    name="job_postal_address"
                                    ref="job_postal_address"
                                    label="Postal Address"
                                    required
                                    disabled
                                />

                                <TextFieldFormsy
                                    className="w-full mt-12"
                                    type="text"
                                    name="job_billing_address"
                                    ref="job_billing_address"
                                    label="Billing Address"
                                    required
                                    disabled
                                />

                                <div className="w-full px-8 mt-12 border-solid border-1 border-grey bg-grey-lighter">
                                    {this.state.contactPersons.length > 1 ? (
                                        <IconButton
                                            color="secondary"
                                            className=' mt-8 float-right'
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.changeContactPerson(this.state.contactPersonsIndex);
                                            }}
                                        >
                                            <Icon>autorenew</Icon>
                                        </IconButton >
                                    ) : ("")}

                                    <TextFieldFormsy
                                        type="hidden"
                                        name="job_cp_id"
                                        value={this.state.contactPersonsIndex}
                                    />

                                    <TextFieldFormsy
                                        className="w-5/6 mb-12 mt-12 mx-12"
                                        type="text"
                                        name="job_cp_name"
                                        ref="job_cp_name"
                                        label="Contact Person"
                                        disabled
                                    />

                                    <TextFieldFormsy
                                        className="md:w-2/5 mb-12 mx-12"
                                        type="text"
                                        name="job_cp_mobile"
                                        ref="job_cp_mobile"
                                        label="Mobile"
                                        disabled
                                    />
                                    <TextFieldFormsy
                                        className="md:w-2/5 mb-12 mx-12"
                                        type="text"
                                        name="job_cp_office"
                                        ref="job_cp_office"
                                        label="Office"
                                        disabled
                                    />
                                    <TextFieldFormsy
                                        className="md:w-2/5 mb-12 mx-12"
                                        type="text"
                                        name="job_cp_home"
                                        ref="job_cp_home"
                                        label="Home"
                                        disabled
                                    />
                                    <TextFieldFormsy
                                        className="md:w-2/5 mb-12 mx-12"
                                        type="text"
                                        name="job_cp_email"
                                        ref="job_cp_email"
                                        label="Email"
                                        disabled
                                    />
                                </div>

                                <TextField
                                    className="w-full md:w-1/3 mt-20"
                                    type="number"
                                    name="job_frequency_tmp"
                                    value={this.state.frequency}
                                    onChange={(ev) => {
                                        this.setNextServiceDate(ev);
                                    }}
                                    label="Frequency"
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">Months</InputAdornment>,
                                    }}
                                />

                                <TextFieldFormsy
                                    type="hidden"
                                    name="job_frequency"
                                    value={this.state.frequency}
                                />

                                <TextFieldFormsy
                                    className="w-full md:w-2/5 mt-20 float-right"
                                    type="date"
                                    value={this.state.nextServiceDate}
                                    name="job_next_service_date"
                                    label="Next Service Date"
                                    required={window.env === "IMC" ? false : true}
                                />
                                <SelectFormsy
                                    className="w-full md:w-1/3 mt-20"
                                    name="job_priority"
                                    label="Priority Level"
                                    value="Normal"
                                    required
                                >
                                    <MenuItem className="popup-value-size" key='1' value='High'>High</MenuItem>
                                    <MenuItem className="popup-value-size" key='2' value='Normal'>Normal</MenuItem>
                                    <MenuItem className="popup-value-size" key='3' value='Low'>Low</MenuItem>
                                </SelectFormsy>
                                {window.env === "IMC" ? 
                                <div className="w-full md:w-2/5 mt-20 float-right"></div> :
                                <TextField
                                    className="w-full md:w-2/5 mt-20 float-right"
                                    type="date"
                                    value={this.state.expectedDate}
                                    name="job_expected_date_tmp"
                                    label="Expected Completed Date"
                                    onChange={(ev) => {
                                        this.setExpectedDate(ev);
                                    }}
                                />}
                                <TextFieldFormsy
                                    type="hidden"
                                    value={this.state.expectedDate}
                                    name="job_expected_date"
                                />
                                <SelectFormsy
                                    className="w-full md:w-1/2 mt-12 pr-20"
                                    name="job_handover_by"
                                    label="Handover By"
                                    value=""
                                >
                                    {this.state.brokers.map(option => (
                                        <MenuItem className="popup-value-size" key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </SelectFormsy>
                                <SelectFormsy
                                    className="w-full md:w-1/2 mt-12"
                                    name="job_recieved_by"
                                    label="Recieved By"
                                    value={this.state.employeeId}
                                >
                                    {this.state.employees.map(option => (
                                        <MenuItem className="popup-value-size" key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </SelectFormsy>
                                <TextFieldFormsy
                                    className="w-full md:w-1/2 mt-12"
                                    type="text"
                                    name="job_no"
                                    ref="job_no"
                                    label="Job No"
                                    value={this.state.jobNo}
                                />
                                <TextFieldFormsy
                                    className="w-full md:w-1/2 mt-12"
                                    type="text"
                                    name="sticker_no"
                                    ref="sticker_no"
                                    label="Sticker No"
                                    onChange={(e) => {
                                        this.setState({ sticker_no: e.target.value });
                                    }}
                                    value={this.state.sticker_no}
                                />
                                <Button
                                    className="m-4 mt-20 float-right"
                                    variant="raised"
                                    color="default"
                                >
                                    Help
                                </Button>
                                <Button
                                    type="reset"
                                    className="m-4 mt-20 float-right"
                                    variant="raised"
                                    color="primary"
                                    onClick={(ev) => {
                                        task = [];
                                        this.setState({ tasks: task });
                                        this.setState({ jobCustomer: null });
                                        this.setState({ jobItem: null });
                                    }}
                                >
                                    Reset
                                </Button>
                                <Button
                                    type="submit"
                                    className="m-4 mt-20 float-right"
                                    variant="raised"
                                    color="secondary"
                                >
                                    Create
                                </Button>
                            </div>
                            <div className="w-full md:w-3/5 px-12 py-24 job-new-margin">


                                <SelectFormsy
                                    className="w-full md:w-1/4 mt-20 pr-12"
                                    name="task_service_type"
                                    ref="task_service_type"
                                    label="Service Type"
                                    value="C"
                                >
                                    <MenuItem className="popup-value-size" key='1' value='C'>Calibrate</MenuItem>
                                    <MenuItem className="popup-value-size" key='2' value='R'>Repair</MenuItem>
                                    <MenuItem className="popup-value-size" key='3' value='RC'>Repair & Calibrate</MenuItem>
                                </SelectFormsy>

                                <Select
                                    className="w-full md:w-3/4 mt-32 float-right"
                                    name="task_instrument"
                                    placeholder="Search Instrument"
                                    value={this.state.jobItem}
                                    onChange={this.setJobItem}
                                    options={this.state.items}
                                />
                                <TextFieldFormsy
                                    type="hidden"
                                    name="task_instrument_name"
                                    ref="task_instrument_name"
                                    value=""
                                />
                                <TextFieldFormsy
                                    type="hidden"
                                    name="task_instrument_id"
                                    ref="task_instrument_id"
                                    value=""
                                />
                                <TextFieldFormsy
                                    className="w-full md:w-1/4 mt-20 pr-12"
                                    type="number"
                                    name="task_qty"
                                    ref="task_qty"
                                    value="1"
                                    label="QTY"
                                />
                                <TextFieldFormsy
                                    className="w-full md:w-3/4 mt-20 float-right"
                                    type="text"
                                    value=""
                                    name="task_remark"
                                    ref="task_remark"
                                    label="Remarks"
                                />
                                <Button
                                    type="button"
                                    className="m-4 my-20 float-left"
                                    variant="raised"
                                    color="default"
                                    onClick={() => {
                                        this.addTask();
                                    }}
                                >
                                    add task
                                    <Icon className="ml-12">send</Icon>
                                </Button>
                                <ReactTable
                                    className={classNames(classes.root, "-striped -highlight w-full")}
                                    data={this.state.tasks}
                                    columns={[

                                        {
                                            Header: "Code",
                                            accessor: "task_code",
                                        },
                                        {
                                            Header: "Instrument",
                                            accessor: "task_instrument",
                                        },
                                        {
                                            Header: "QTY",
                                            accessor: "task_qty",
                                        },
                                        {
                                            Header: "Remarks",
                                            accessor: "task_remark",
                                        },
                                        {
                                            Header: "",
                                            width: 128,
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <IconButton
                                                        className='text-green'
                                                        onClick={(ev) => {
                                                            this.openSubTaskDialog(row.original.sub_tasks);
                                                        }}
                                                    >
                                                        <Icon>remove_red_eye</Icon>
                                                    </IconButton>
                                                    <IconButton
                                                        className='text-red'
                                                        onClick={(ev) => {
                                                            this.removeTaskConfirm(row.original);
                                                        }}
                                                    >
                                                        <Icon>delete</Icon>
                                                    </IconButton>
                                                </div>
                                            )
                                        }
                                    ]}
                                    defaultPageSize={5}
                                    noDataText="No Tasks"
                                />

                            </div>

                        </div>

                    </Formsy>

                    <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="sm">

                        <AppBar className="flex w-full h-56 app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    Sub Tasks
                                </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeSubTaskDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <DialogContent className="p-24">
                            <ReactTable
                                className={classNames(classes.root, "-striped -highlight w-full")}
                                data={subTasks}
                                columns={[

                                    {
                                        Header: "Code",
                                        accessor: "subTask_code",
                                    },
                                    {
                                        Header: "Instrument",
                                        accessor: "subTask_instrument",
                                    }
                                ]}
                                defaultPageSize={5}
                                noDataText="No Sub Tasks"
                            />
                        </DialogContent>
                        <DialogActions className="justify-right pl-16">

                        </DialogActions>
                    </Dialog>

                    <Dialog
                    open={this.state.openServiceTypeDialog}
                    onClose={this.handleCloseServiceTypeDialog}
                    >
                        <DialogContent>
                            <DialogContentText className="pb-8">You can add below items as the Tasks to the Job</DialogContentText>
                        <ReactTable
                                    className={classNames(classes.root, "-striped -highlight w-full z-10")}
                                    data={this.state.quotationItems}
                                    columns={[
                                        {
                                            Header: "Instrument",
                                            accessor: "ITEM_NAME",
                                            width: 150,
                                        },
                                        {
                                            Header: "QTY",
                                            accessor: "ITEM_QTY",
                                            width: 64,
                                            className: "justify-center"
                                        },
                                        {
                                            Header: "Service Type",
                                            width: 128,
                                            Cell: row => (
                                               
                                                <select
                                                    className="w-full"
                                                    name="service_type"
                                                    value={row.original.SERVICE_TYPE}
                                                    onChange={(event) => this.changeServiceType(event, row.index)}

                                                >
                                                    <option>--Select--</option>
                                                    {this.state.serviceTypes.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            )
                                        },
                                        {
                                            Header: "",
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    {!row.original.added ? <Button
                                                        className='text-blue'
                                                        onClick={() => {
                                                            this.addTaskFromQuatation(row.index, row.original);
                                                        }}
                                                    >
                                                        Add
                                                    </Button>
                                                    :
                                                    <Button
                                                        className='text-blue'
                                                        disabled
                                                    >
                                                        Added
                                                    </Button>
                                        }
                                                </div>
                                            )
                                        }
                                    ]}
                                    defaultPageSize={5}
                                    noDataText="No Tasks"
                                />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={this.handleCloseServiceTypeDialog}>Close</Button>
                        </DialogActions>
                    </Dialog>
                    <AddCustomer openCustomerDialog={this.state.openCustomerDialog} closeCustomerDialog={this.closeCustomerDialog} setLoader={this.setLoader} />

                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        if (this.props.user.employeeId) {
            this.setState({ employeeId: this.props.user.employeeId });
        }

        this.setNextServiceDate({ target: { name: '' } });

        this.getCustomerList();
        this.getQuotations();

        //==============================================================================

        var broker = [];

        axios.get(window.salesServer + '/broker/getBrokerList')
            .then(response => {

                for (let i = 0; i < response.data.brokers.length; i++) {

                    broker.push({
                        value: response.data.brokers[i].ID_SALES_BROKER,
                        label: response.data.brokers[i].NAME
                    });
                }
                this.setState({ brokers: broker });
            });

        //==============================================================================

        var employee = [];

        axios.get(window.hrmServer + '/employeeView/getAllEmployeeOfficeDetails')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {
                    employee.push({
                        value: response.data[i].ID_EMPLOYEE_PROFILE,
                        label: response.data[i].FIRST_NAME + ' (' + response.data[i].DESIGNATION + ' ' + response.data[i].LOCATION_NAME + ')'
                    });
                }
                this.setState({ employees: employee });
            });

        //==============================================================================

        var items = [];

        axios.get(window.inventoryServer + '/inventory/get/itemView')
            .then(response => {

                for (let i = 0; i < response.data.result.length; i++) {

                    items.push({
                        value: response.data.result[i].ID_ITEM,
                        label: response.data.result[i].GENERAL_NAME + ' [ Rs.' + response.data.result[i].RETAIL_PRICE + ' ]',
                        text: response.data.result[i].GENERAL_NAME
                    });
                }
            });

        axios.get(window.inventoryServer + '/inventory/get/serviceNames')
            .then(response => {
                for (let i = 0; i < response.data.result.length; i++) {
                    items.push({
                        value: response.data.result[i].ID_ITEM,
                        label: response.data.result[i].GENERAL_NAME + ' [ Rs.' + response.data.result[i].RETAIL_PRICE + ' ]',
                        text: response.data.result[i].GENERAL_NAME
                    });
                }
               ;
            });
        console.log('arr', items)
        this.setState({ items: items })
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withStyles({ withTheme: true })(withRouter(connect(mapStateToProps)(withAlert(jobNew))));


// WEBPACK FOOTER //
// ./src/main/content/crm/jobNew/jobNew.js